export interface PaymentBalacingConfiguration {
  completeButtonText?: string;
  location: 'guardians-app' | 'externals-app';
}

export interface PaymentBalacingPayment {
  asyncStatus: string;
  id: string;
  paymentProcessorId: string;
  status: PaymentBalacingPaymentStatus;
}

export enum PaymentBalacingPaymentStatus {
  'PAID' = 'Pagado',
  'PROCESSING' = 'Procesando Pago',
  'REJECTED' = 'Rechazado',
}

export interface PaymentBalacingSSE {
  message: string;
  payment: PaymentBalacingPayment;
  status: PaymentBalacingSSEStatus;
}

export enum PaymentBalacingSSEStatus {
  'UPDATED' = 'updated',
}

export enum PaymentBalacingStatus {
  COMPLETED = 'completed',
  COMPLETED_ERROR = 'completed-error',
  ERROR = 'error',
  LOADING = 'loading',
  SUCCESS = 'success',
}

export interface PaymentBalacingStatusEvent {
  data?: Array<{
    processor: 'Kushki' | 'Memphis';
    status: PaymentBalacingPaymentStatus;
  }>;
  error?: 'api-error' | 'declined' | 'processing-error' | 'status-error';
  id: number;
  paymentId?: string;
  processors?: Array<'Kushki' | 'Memphis'>;
  status: PaymentBalacingStatus;
}
